/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem3Editor extends Serenity.Extensions.GridEditorBase<PsAdvPromoItem3Row> {
        protected getColumnsKey() { return "AdvPromo.PsAdvPromoItem3"; }
        protected getDialogType() { return PsAdvPromoItem3Dialog; }
        protected getLocalTextPrefix() { return PsAdvPromoItem3Row.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Add รายการโปรโมชั่น"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    onClick: () => {
                        this.createEntityDialog(this.getItemType(), dlg => {


                            var dialog = dlg as PsAdvPromoItem3Dialog;
                            dialog.onSave = (opt, callback) => this.save(opt, callback);
                            var entity = this.getNewEntity() as PsAdvPromoItem3Row;

                            entity.PmGroupId = this.myPassValue;
                            // console.log(entity.PmGroupId)
                            // console.log(this.myPassValue)
                            dialog.Pass = this.myPassValue


                            dialog.loadEntityAndOpenDialog(entity, false);
                           
                        });
                    },
                }
            );
            
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

